export const newVersion = 'newVersionAvailable';
